export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7307.9213d43e.jpg";